import Link from "next/link";
import { Trans } from "@lingui/macro";
import { useRouter } from "next/router";
import {
  VideoPageQuery,
  useVideosIndexPageQuery,
} from "@graphql/generated/graphql";
import { CompactVideoCard } from "@components/videos/video-card";
import { useEffect, useRef, useState } from "react";
import { InfiniteList } from "./infinite-list";

interface IVideosTrendingNow {
  currentVideoId: VideoPageQuery["video"]["id"];
}

const VideosTrendingNow: React.FunctionComponent<IVideosTrendingNow> = ({
  currentVideoId,
}) => {
  const { locale } = useRouter();
  const hasFeaturedVidInList = useRef(0);
  const [videos, setVideos] = useState([]);

  const { data, loading, fetchMore, error } = useVideosIndexPageQuery({
    variables: {
      limit: 5,
      languageCodes: [locale],
      languageCode: locale,
    },
  });

  //Remove featured video from the list if it exists by checking the latest 5 results
  useEffect(() => {
    if (data) {
      const fetchedVideos = [...data.allVideos].slice(-5);
      if (hasFeaturedVidInList.current == 1) {
        setVideos([...videos, ...fetchedVideos]);
      } else {
        const index = fetchedVideos
          .slice(-5)
          .findIndex((video) => video.id === currentVideoId);
        if (index != -1) {
          fetchedVideos.splice(index, 1);
          hasFeaturedVidInList.current = 1;
          setVideos([...videos, ...fetchedVideos]);
        } else {
          setVideos([...videos, ...fetchedVideos]);
        }
      }
    }
  }, [data]);

  if (loading || error)
    return (
      <div className="py-64 text-center font-sen text-text-lightest">
        <Trans>Loading...</Trans>
      </div>
    );

  return (
    <div className="">
      <p className="pb-8 font-poppins text-xl font-bold text-text-darkest">
        <Trans>More videos for you</Trans>
      </p>

      {videos && !error && (
        <InfiniteList
          infiniteLoadingOption={{
            dataLength: videos.length || 0,
            next: () => {
              fetchMore({
                variables: {
                  limit: 20,
                  offset: videos.length,
                  languageCodes: [locale],
                },
              });
            },
            loader: (
              <p className="py-4 text-center font-sen text-text-lightest">
                <Trans>Loading...</Trans>
              </p>
            ),
          }}
        >
          <div className="divide-y divide-off-white md:grid md:grid-cols-2 md:gap-x-6 md:gap-y-8 md:divide-y-0">
            {videos.map((video) => (
              <div className="py-3" key={video.id}>
                <Link href={`/videos/${video.id}`} passHref key={video.id}>
                  <a>
                    <CompactVideoCard video={video} />
                  </a>
                </Link>
              </div>
            ))}
          </div>
        </InfiniteList>
      )}
    </div>
  );
};
export default VideosTrendingNow;
